export default {
    'name': 'member-ru',
    'width': '32',
    'height': '32',
    'viewBox': '0 0 32 32',
    'data': '<path fill-rule=\'evenodd\' clip-rule=\'evenodd\' d=\'M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32ZM18.82 23.8V18.3C18.46 18.4733 17.9933 18.6133 17.42 18.72C16.86 18.8267 16.3 18.88 15.74 18.88C13.9133 18.88 12.5067 18.3867 11.52 17.4C10.5333 16.4133 10.04 14.9333 10.04 12.96V9.7H12.6V12.84C12.6 14.1733 12.8867 15.1467 13.46 15.76C14.0333 16.3733 14.8867 16.68 16.02 16.68C16.5 16.68 16.98 16.6333 17.46 16.54C17.9533 16.4333 18.4067 16.2733 18.82 16.06V9.7H21.38V23.8H18.82Z\' fill=\'#19405B\'/>'
}
